import { AlertTriangle } from 'lucide-react';
import { Folder } from './types';

interface DeleteFolderConfirmationProps {
  folder: Folder;
  hasClasses: boolean;
  onCancel: () => void;
  onConfirm: (moveClassesToParent: boolean) => void;
}

const DeleteFolderConfirmation = ({
  folder,
  hasClasses,
  onCancel,
  onConfirm
}: DeleteFolderConfirmationProps) => {
  // Flat folder model: no parent-child relationship. We don't move classes to a parent.
  // Deleting a folder only removes class associations; classes themselves are not deleted.

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-gray-800 rounded-lg p-6 w-full max-w-md">
        <div className="flex items-start mb-4">
          <div className="flex-shrink-0 mr-3">
            <AlertTriangle className="w-6 h-6 text-amber-500" />
          </div>
          <div>
            <h2 className="text-xl font-bold text-white mb-2">Delete Folder</h2>
            <p className="text-gray-300 mb-4">
              Are you sure you want to delete the folder "{folder.name}"? This action cannot be undone.
            </p>
            
            {hasClasses && (
              <div className="mb-4">
                <div className="bg-gray-700 rounded-lg p-3 mb-2">
                  <p className="text-sm text-gray-300">
                    Deleting this folder will remove its association from any classes currently in it.
                    Classes are not deleted.
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
        
        <div className="flex gap-4">
          <button
            onClick={onCancel}
            className="flex-1 bg-gray-700 text-white rounded-lg px-4 py-2 hover:bg-gray-600 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={() => onConfirm(true)}
            className="flex-1 bg-red-500 text-white rounded-lg px-4 py-2 hover:bg-red-600 transition-colors"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteFolderConfirmation;
